// removed by extract-text-webpack-plugin
module.exports = {"RadioWrapper":"Radio-module__RadioWrapper__ZUzTG","RadioWrapperLarger":"Radio-module__RadioWrapperLarger__Z173e","RadioCircle":"Radio-module__RadioCircle__1Npsx","RadioCircleSelected":"Radio-module__RadioCircleSelected__hEoy-","RadioText":"Radio-module__RadioText__2ORSa","RadioTextSelected":"Radio-module__RadioTextSelected__6xY8a","OptionNames":"Radio-module__OptionNames__3--TG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/RadioGroupIcon/Radio/Radio.module.css
// module id = 1727
// module chunks = 29